const AccordionData = [
    {
        title: "What type of information can I find on my profile?",
        content: "Your JobCritics.com profile includes both professional and academic reviews, along with AI-generated summaries of your feedback. You can showcase your work experiences, educational background, and language proficiencies. Reviews received from colleagues, peers, or employers will also be visible on your profile, helping you build a credible and well-rounded professional reputation."
    },
    {
        title: "Is my identity protected when I post a review?",
        content: "Absolutely. All reviews are submitted anonymously. We do not collect or share any personally identifiable information."
    },
    {
        title: "Can JobCritics help in my job search?",
        content: "Yes. JobCritics supports your job search by offering verified reviews from colleagues and peers that highlight your professional or academic strengths and credibility. In addition your profile showcases trusted feedback that you can share with recruiters to enhance your career prospects."
    }
    ,
    {
        title: "Can I review a Employer for whom I worked years ago?",
        content: "Yes, you can share past experiences as long as the information is honest and relevant to others exploring that company."
    },
    {
        title: "What should I include in a helpful review?",
        content: "Mention the work culture, leadership style, learning opportunities, challenges, and any specific experiences that could help others make informed decisions. Give honest feedbacks which helps your colleagues or peers for career credibility."
    },
    {
        title: "How does JobCritics support career growth?",
        content: "By offering real employee insights, company comparisons, and peer ratings, JobCritics helps you make better career choices and professional connections."
    }

    ,
    {
        title: "Can I report a fake or abusive review?",
        content: `Yes, every review has a "Report" option. Our moderation team investigates and removes content that violates our community guidelines.`,
    }
    ,
    {
        title: "How is my data kept secure?",
        content: "JobCritics uses encryption, secure servers, and privacy-first policies to protect your personal data and keep your activity confidential."
    },
    {
        title: "Are peer reviews as valuable as company reviews?",
        content: "Absolutely! Peer reviews offer unique insights into individual work ethics, collaboration, and leadership—great for networking and team evaluations."
    },
    {
        title: "How can I improve my profile credibility?",
        content: "Complete your profile, write detailed reviews, and engage respectfully with others to build a trustworthy presence on the platform."
    }
]

const AccordionData02 = [
    {
        title: "What do you mean by item and end product?",
        content: "Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard dummy text ever when an unknown printer took a galley. Lorem ipsum is simply."
    },
    {
        title: "What are some examples of permitted end products?",
        content: "Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard dummy text ever when an unknown printer took a galley. Lorem ipsum is simply."
    },
    {
        title: "Am i allowed to modify the item that i purchased?",
        content: "Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard dummy text ever when an unknown printer took a galley. Lorem ipsum is simply."
    },
]

const AccordionData05 = [
    {
        time: "06:00 - 07:00",
        title: 'Yoga and Pilates',
        content: 'Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.',
        author: 'By Edward watson'
    },
    {
        time: "08:00 - 09:00",
        title: 'Energy Blast',
        content: 'Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.',
        author: 'By Bryan jonhson'
    },
    {
        time: "10:00 - 11:00",
        title: 'Cardio Workout',
        content: 'Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.',
        author: 'By Jeremy dupont',

    },
    {
        time: "11:00 - 12:00",
        title: 'Athletics Classes',
        content: 'Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.',
        author: ' By Edward watson'
    },
    {
        time: "13:00 - 15:00",
        title: 'Boxercise',
        content: 'Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.',
        author: ' By Bryan jonhson',

    }
]

export {AccordionData ,AccordionData02,AccordionData05};